export default "__VITE_ASSET__BFY$PtKX__"